// import external modules
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import API from '../../utils/API';

import logo from '../../assets/img/logos/simple events logo.png';
import loginBG from '../../assets/img/backgrounds/corporate_img.jpg';

import InputField from '../../components/inputs/inputField';

class ResetPassword extends Component {
	constructor(props) {
		super(props);
		const tokenIndex = window.location.href.indexOf('key=') + 4;
		let userToken = tokenIndex > -1 && window.location.href.substr(tokenIndex);
		if (!userToken) {
			window.location.replace('/');
		}
		this.state = {
			userToken: userToken,
			password: '',
			confirmPassword: '',
			error: '',
			disableSubmit: true,
			errorTrigger: false,
			formatErrorTrigger: false,
			matchErrorTrigger: false,
			isConfirmed: false
		};
	}

	submit = (e) => {
		const { password, userToken } = this.state;

		e.preventDefault();
		e.persist();

		const data = {
			userToken: userToken,
			newPassword: password
		};
		API()
			.post(`/auth/resetPassword`, data)
			.then((res) => {
				this.setState({ isConfirmed: true });
			})
			.catch((err) => {
				this.setState({ error: err.response.data });
			});
	};

	validatePassword = (password) => {
		const requirements = {
			length: password.length >= 10,
			uppercase: /[A-Z]/.test(password),
			lowercase: /[a-z]/.test(password),
			number: /\d/.test(password),
			specialChar: /[@$!%*?&]/.test(password)
		};
		return { requirements, valid: Object.values(requirements).every((val) => val) };
	};

	generatePasswordChecklist = (requirements) => {
		return (
			<ul className="password-checklist">
				<li className={requirements.length ? 'green' : 'red'}>At least 10 characters</li>
				<li className={requirements.uppercase ? 'green' : 'red'}>At least one uppercase letter</li>
				<li className={requirements.lowercase ? 'green' : 'red'}>At least one lowercase letter</li>
				<li className={requirements.number ? 'green' : 'red'}>At least one number</li>
				<li className={requirements.specialChar ? 'green' : 'red'}>At least one special character (@$!%*?&)</li>
			</ul>
		);
	};

	render() {
		const {
			password,
			confirmPassword,
			error,
			formatErrorTrigger,
			matchErrorTrigger,
			isConfirmed
		} = this.state;
		const disableSubmit = !formatErrorTrigger && !matchErrorTrigger && (password === '' || confirmPassword === '');
		return (
			<div className='w-100 h-100 flex column aic jcc' style={{ background: '#f0f0f0', backgroundImage: `url(${loginBG})`, backgroundSize: 'cover', backgroundPositionX: 'center' }}>
				<div className='systemToolbar flex aic' style={{ position: 'absolute', top: 0, height: 100 }} >
					<div className="flex" >
						<div className="navLogo c-pointer" onClick={() => window.location.href = "/"}>
							<img src={logo} alt="logo" style={{ maxHeight: 'unset', height: 35, filter: 'invert(1)' }} />
						</div>
					</div>
				</div>
				<div className='neuCard w-100' style={{ background: 'white', border: 'none', maxWidth: 430, padding: 30 }}>
					{!isConfirmed ? (
						<>
							<h1 className='mb-30 text-c' style={{ fontWeight: 500, fontSize: 24 }}>Create your password</h1>
							<p className='text-c mb-30'>
								Please create a new password for your account. Your password must be at least 10 characters long and include at least one uppercase letter, one lowercase letter, one number, and one special character.
							</p>
							<InputField
								label={'New Password'}
								type={'password'}
								onChange={(e) => {
									const val = e.currentTarget.value;
									this.setState({ password: val, formatErrorTrigger: !this.validatePassword(val).valid, matchErrorTrigger: confirmPassword !== val });
								}}
								value={password}
								errorTrigger={formatErrorTrigger}
								errorMessage={'Invalid password'}
								placeholder={'At least 10 characters'}
								alert={formatErrorTrigger && this.generatePasswordChecklist(this.validatePassword(password).requirements)}
							/>

							<InputField
								label={'Confirm New Password'}
								type={'password'}
								onChange={(e) => {
									const val = e.currentTarget.value;
									this.setState({ confirmPassword: val, matchErrorTrigger: password !== val });
								}}
								value={confirmPassword}
								errorTrigger={matchErrorTrigger}
								errorMessage={'Passwords do not match'}
								placeholder={'Confirm your password'}
							/>

							<button
								onClick={this.submit}
								className={`prim ${disableSubmit ? 'inactive' : ''} w-100 mt-30`}
								disabled={disableSubmit}
							>
								Set new password
							</button>
							{error && <p className='text-c small mt-5' style={{ color: 'red' }}>{error}</p>}
						</>
					) : (
						<>
							<h1 className='mb-30 text-c' style={{ fontWeight: 500, fontSize: 24 }}>Password Has Been Reset</h1>
							<p className='text-c mb-30'>
								Success! Your password has been set. Please head to the login page to access your account.
							</p>
							<p className='flex jcc aic text-c mt-20 small'>
								<Link to={'/'}>Back to login</Link>
							</p>
						</>
					)}
				</div>
			</div>
		);
	}
}

export default ResetPassword;
